<app-apps-banner></app-apps-banner>

<section class="mt-5 container-specification">
  <div class="container">
    <div class="row pb-80">
      <div class="col-lg-8 pe-md-4 pe-xl-5 border-right sm-border-none">

        <div class="border-bottom pb-3 d-md-none d-block">
          <!-- <p class="back-link">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </p> -->

        <a class="back-link linked" routerLink="/apps">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </a>

        <div class="d-flex">
          <img src="../assets/images/icons/container-specification.png" class="card-img-top img-fluid app-img me-4" alt="Container Specification">
          <h2>Container Specification</h2>
        </div>
      </div>

      <div class="d-md-flex align-items-md-center border-bottom pb-3 d-none d-md-flex">
        <img src="../assets/images/icons/container-specification.png" class="card-img-top img-fluid app-img me-4" alt="Container Specification">
        <div>
          <!-- <p class="back-link mb-0">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </p> -->
        <a class="back-link linked" routerLink="/apps">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </a>
        <h2>Container Specification</h2>
      </div>
    </div>

    <form class="border-bottom mb-3">
      <div class="row">
        <div class="col-lg-7 col-md-7">
          <div class="apps-form-input">
            <div class="form-group d-flex align-items-center mb-0">
              <label for="exampleFormControlSelect1" class="text-white">Select container type :</label>
              <select class="form-select" id="exampleFormControlSelect1" [ngModelOptions]="{standalone: true}" [(ngModel)]="SelectContainerSpecification" (ngModelChange)="onSelected()">
                @for (item of containerSpecificationList; track item) {
                  <option [value]="item">{{item}}</option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 ps-lg-0">
          <div class="apps-form-result">
            <div class="form-group d-flex align-items-center mb-0">
              <label for="exampleFormControlSelect1">Show results in :</label>
              <select class="form-control" id="exampleFormControlSelect1" [ngModelOptions]="{standalone: true}" [(ngModel)]="SelecteBMeasurementSystem" (ngModelChange)="onShowResultSelecte()">
                @for (item of bMeasurementSystemList; track item) {
                  <option [value]="item.id">{{item.name}}</option>
                }

              </select>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="containerSpecificationDetails bg-gray p-2 p-sm-3">
      @if (isLoader) {
        <div class="loader">
          <div class="loader-icon">
            <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      }
      <table class="table table-striped table-bordered">
        <thead class="table-dark">
          <tr>
            <th scope="col">Dimensions</th>
            <th scope="col">Length</th>
            <th scope="col">Width</th>
            <th scope="col">Height</th>
          </tr>
        </thead>
        <tbody>
          @for (item of containerSpecDetails; track item) {
            <tr>
              <th scope="row">Exterior</th>
              <td>{{getValue(item.iExternallength)}} @if (SelecteBMeasurementSystem==='1') {
                <span>ft</span>
                } @if (SelecteBMeasurementSystem==='2') {
                <span>m</span>
              }</td>
              <td>{{getValue(item.iExternalwidth)}} @if (SelecteBMeasurementSystem==='1') {
                <span>ft</span>
                } @if (SelecteBMeasurementSystem==='2') {
                <span>m</span>
              }</td>
              <td>{{getValue(item.iExternalheight)}} @if (SelecteBMeasurementSystem==='1') {
                <span>ft</span>
                } @if (SelecteBMeasurementSystem==='2') {
                <span>m</span>
              }</td>
            </tr>
          }
          @for (item of containerSpecDetails; track item) {
            <tr>
              <th scope="row">Interior</th>
              <td>{{getValue(item.iInternallength)}} @if (SelecteBMeasurementSystem==='1') {
                <span>ft</span>
                } @if (SelecteBMeasurementSystem==='2') {
                <span>m</span>
              }</td>
              <td>{{getValue(item.iInternalwidth)}} @if (SelecteBMeasurementSystem==='1') {
                <span>ft</span>
                } @if (SelecteBMeasurementSystem==='2') {
                <span>m</span>
              }</td>
              <td>{{getValue(item.iInternalheight)}} @if (SelecteBMeasurementSystem==='1') {
                <span>ft</span>
                } @if (SelecteBMeasurementSystem==='2') {
                <span>m</span>
              }</td>
            </tr>
          }
        </tbody>
      </table>

      <div class="bg-white p-3">
        <div class="row">
          <div class="col-lg-5">
            @if (containerSpeceImage) {
              <img [src]="'../assets/images/apps/' + containerSpeceImage + '.png'" alt="Flat Rack" class="img-fluid">
            }
          </div>

          <div class="col-lg-7">
            @for (item of containerSpecDetails; track item) {
              <div class="row">
                <div class="col-lg-6 col-md-6 pe-md-0 border-after pb-3">
                  <p class="border-bottom pb-2 result-heading"><strong>Weight</strong></p>
                  <p class="result-value">Tare: {{noDecimal(item.iTare)}} @if (SelecteBMeasurementSystem==='1') {
                    <span>lb</span>
                    }@if (SelecteBMeasurementSystem==='2') {
                    <span>kg</span>
                  }</p>
                  <p class="result-value">Net Weight: {{noDecimal(item.iNetweight)}} @if (SelecteBMeasurementSystem==='1') {
                    <span>lb</span>
                    }@if (SelecteBMeasurementSystem==='2') {
                    <span>kg</span>
                  }</p>
                  <p class="result-value">MGW: {{noDecimal(item.iMaxgrossweight)}} @if (SelecteBMeasurementSystem==='1') {
                    <span>lb</span>
                    }@if (SelecteBMeasurementSystem==='2') {
                    <span>kg</span>
                  }</p>
                </div>
                <div class="col-lg-6 col-md-6 ps-md-0 pe-md-0 pb-3">
                  <p class="border-bottom pb-2 result-heading"><strong>Door Opening Volume</strong></p>
                  <p class="result-value">Height: {{getValue(item.iDoorheight)}} @if (SelecteBMeasurementSystem==='1') {
                    <span>ft</span>
                    }@if (SelecteBMeasurementSystem==='2') {
                    <span>m</span>
                  }</p>
                  <p class="result-value">Width: {{getValue(item.iDoorwidth)}} @if (SelecteBMeasurementSystem==='1') {
                    <span>ft</span>
                    }@if (SelecteBMeasurementSystem==='2') {
                    <span>m</span>
                  }</p>
                  <!-- <p class="result-value">{{getValue(item.iCube)}} <span *ngIf="SelecteBMeasurementSystem==='1'">Cubic Feet</span><span *ngIf="SelecteBMeasurementSystem==='2'">Cubic Meter</span></p> -->
                </div>
                <div class="col-lg-6 col-md-6 pe-md-0 border-after">
                  <p class="border-bottom pb-2 result-heading"><strong>Volume</strong></p>
                  <p class="result-value">{{getValue(item.iCube)}} @if (SelecteBMeasurementSystem==='1') {
                    <span>Cubic Feet</span>
                    }@if (SelecteBMeasurementSystem==='2') {
                    <span>Cubic Meter</span>
                  }</p>
                </div>
                <div class="col-lg-6 col-md-6 ps-md-0 pe-md-0 d-none d-sm-block">
                  <p class="border-bottom pb-2 result-heading" style="color: #fff;"><strong>Volume</strong></p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-4 ps-md-4 ps-xl-5 pe-lg-0">
    <app-other-apps [menu]="'specification'"></app-other-apps>
  </div>
</div>

</div>
</section>

<app-sat></app-sat>

<router-outlet></router-outlet>